
import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import NavMeetingsMixin from '@/core/mixins/nav-meetings.mixin';
import NavMixin from '@/core/mixins/nav.mixin';
import EdToggleMeetings from '@/core/components/ed-toggle-meetings/ed-toggle-meetings.vue';
import EdToggleTransparency from '@/core/components/ed-toggle-transparency/ed-toggle-transparency.vue';
import { CLOSE_NAV_MEETING_TOOLS_EVENT } from '@/content/values/ed-presentation-mode.values';

@Component({
  name: 'ed-nav-meetings-tools',
  components: {
    EdToggleMeetings,
    EdToggleTransparency
  }
})
export default class EdNavMeetingsTools extends Mixins(NavMeetingsMixin, NavMixin) {

  public navMenuID: string = 'EdNavMeetingsTools';
  public toolOptionsID : string = 'toolOptions';
  public menuToolsActive = false;

  get isPresentationModeTeacher(){
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  public openMeetingToolsMenu() : void {    
    this.menuToolsActive = !this.menuToolsActive;
  }

  private hideMenu() : void {
    this.menuToolsActive = false;
  }

  private createEventClick() : void {
    window.addEventListener('click', (event : any) => {
      let path = event.path || (event.composedPath && event.composedPath());
      
      let found = path.filter((el : any) => {
        return el.id === this.navMenuID || el.id === this.toolOptionsID;
      });

      if (found.length === 0){
        this.hideMenu();
      }
    });
  }

  mounted() {
    this.createEventClick();
    this.$edEventBus.$on(CLOSE_NAV_MEETING_TOOLS_EVENT, this.hideMenu);
  }

  beforeDestroy() {
    this.$edEventBus.$off(CLOSE_NAV_MEETING_TOOLS_EVENT, this.hideMenu);
  }
}